module.exports = __webpack_public_path__ + "img/20220805141449.aaeb1fec.jpg";